import { Wordmark } from '@/Components/Wordmark';
import { PhoneCTA } from '@/Components/PhoneCTA';

/**
 * Desktop top navigation. Renders the wordmark, primary nav, and the
 * always-present phone CTA on the right.
 *
 *   <Header active="practice-areas" phone="1-833-INJURY-1" />
 */

export interface HeaderNavItem {
    key: string;
    label: string;
    href: string;
}

export interface HeaderProps {
    phone: string;
    active?: string;
    nav?: HeaderNavItem[];
    className?: string;
}

const DEFAULT_NAV: HeaderNavItem[] = [
    { key: 'practice-areas', label: 'Practice areas', href: '/' },
    { key: 'states', label: 'States', href: '/' },
    { key: 'resources', label: 'Resources', href: '/resources' },
    { key: 'for-attorneys', label: 'For attorneys', href: '/for-attorneys' },
];

export function Header({
    phone,
    active,
    nav = DEFAULT_NAV,
    className,
}: HeaderProps) {
    const cls = [
        'hidden md:flex items-center justify-between',
        'h-16 px-6 bg-card border-b border-rule',
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <header className={cls} aria-label="Site navigation">
            <a href="/" className="inline-flex" aria-label="injury.help home">
                <Wordmark size={22} />
            </a>
            <nav
                className="flex items-center gap-1"
                aria-label="Primary navigation"
            >
                {nav.map((item) => {
                    const isActive = item.key === active;
                    return (
                        <a
                            key={item.key}
                            href={item.href}
                            aria-current={isActive ? 'page' : undefined}
                            className={[
                                'inline-flex items-center h-10 px-3 text-[14px] rounded-md transition-colors',
                                isActive
                                    ? 'text-ink bg-paper-deep'
                                    : 'text-ink-soft hover:text-ink hover:bg-paper-deep',
                            ].join(' ')}
                        >
                            {item.label}
                        </a>
                    );
                })}
            </nav>
            <PhoneCTA number={phone} size="md" />
        </header>
    );
}

export default Header;
